import React from 'react';

export default class Notification extends React.Component {
  constructor(props) {
    super();
    this.state = {

    };
  }

	render() {
    const { isError, message } = this.props;
    if(message) {
      return (
        <div className={`alert message-box ${isError ? 'alert-danger' : 'alert-success'}`}>
            {message !== 'ERROR_NETWORK_CONNECTION' ? message :
            (<span>There was an error. Please check your network connectivity and try again. In case this error persists please contact us at <a href="mailto:contact@sensationax.com">contact@sensationax.com</a></span>)}
        </div>
      )
    } else {
      return (null)
    }
	}
}
